import { z } from 'zod/v4';

import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const displayRestrictionTypeOptions = [
  'AlwaysOff',
  'AlwaysOn',
  'BasedOnTruckRestrictions',
] as const;

export const displayRestrictionTypeSchema = createEnumSchemaPreprocessor(
  z.enum(displayRestrictionTypeOptions),
  displayRestrictionTypeOptions
);

export type DisplayRestrictionType = z.infer<
  typeof displayRestrictionTypeSchema
>;
